import React from 'react';

// The outlined D20 motif shared by the physical-shop and product pages.
export default function GameDice({ className = '' }) {
  return <svg aria-hidden="true" viewBox="0 0 140 160" fill="none" stroke="currentColor" strokeWidth="1.4" className={className}>
    <path d="m70 4 62 38v76l-62 38-62-38V42L70 4Zm0 0L36 62 8 42m124 0-28 20L70 4M8 118l28-56h68l28 56-62 38-34-94 68 0-34 94M8 118h124" />
  </svg>;
}
